/**
 * Flow types for OTP / password screens.
 * These values are sent to the backend in the `flowType` metadata field
 * and also used as the `flow` query param in the URL so the frontend
 * knows which endpoint to call and which texts to display.
 */
const FLOW_TYPES = {
    ONBOARDING: 'ONBOARDING',
    EMAIL_CHANGE: 'EMAILCHANGE',
    PASSWORD: 'PASSWORD',
};

export default FLOW_TYPES;
